import React from "react";
import { ErrorMessage, useField } from "formik";
// import "../../screens/Common/Common.css";
import "../../Common/Common.css";

export const TextField = ({
  label,
  isRequired,
  touched,
  readOnly=false,
  errClassName = "",
  ...props
}) => {
  const [field, meta] = useField(props);

  //For the autocomplete property
  const onFocus = (event) => {
    if (event.target.autocomplete) {
      event.target.autocomplete = "whatever";
    }
  };

  return (
    <div className="mb-2">
      <label htmlFor={field.name} className="label-inpt">
        {label} {isRequired && <span className="astrk">*</span>}
      </label>
      <input
        className={`form-control shadow-none  inpt-txt-size`}
        style={{ background: "#ffffff" }}
        {...field}
        {...props}
        autoComplete="off"
        onFocus={onFocus}
        readOnly={readOnly}
      />

      {meta.error ? (
        <ErrorMessage
          component="div"
          name={field.name}
          className={`errorMsg ${errClassName}`}
        />
      ) : null}
    </div>
  );
};
